import React, { useEffect, useState, Fragment } from 'react'
import { Button, Typography, IconButton, Grid, FormControl, InputAdornment, InputLabel, FilledInput } from '@material-ui/core'
import { Save, Visibility, VisibilityOff } from '@material-ui/icons'
import { Trans } from 'react-i18next'
import i18n from 'i18next'
import { useAuth } from '../context/useFetch'
import { useAlert } from '../reducer'

export const Security = () => (
  <Fragment>
    <Typography variant="h2" component="h1">
      <Trans i18nKey="profile.entreprise.security_tab.title" />
    </Typography>
    <Grid className="profileSection">
      <ListOfFields />
    </Grid>
  </Fragment>
)

const ListOfFields = () => {
  const [oldPassword, setOldPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmNewPassword, setConfirmNewPassword] = useState('')

  const [passwordCheck, setPasswordCheck] = useState(false)

  useEffect(() => {
    if (newPassword === confirmNewPassword) {
      setPasswordCheck(true)
    } else {
      setPasswordCheck(false)
    }
  }, [newPassword, confirmNewPassword])

  const auth = useAuth()
  const { email } = auth.getToken()
  const alert = useAlert()

  const handleConfirmPassword = (e) => {
    e.preventDefault()

    auth
      .login(email, oldPassword)
      .then((res) => {
        if (newPassword === confirmNewPassword && newPassword !== oldPassword) {
          auth
            .fetch('profile', {
              method: 'PUT',
              body: {
                user_attributes: {
                  id: auth.getToken().id,
                  password: newPassword,
                  password_confirmation: confirmNewPassword
                }
              }
            })
            .then(() => alert('notice', <Trans i18nKey="alerts.password_changed" />))
            .catch((error) => {
              alert('error', <Trans i18nKey="alerts.error" />)
            })
        } else {
          alert('error', <Trans i18nKey="alerts.password_same" />)
        }
      })
      .catch((err) => {
        alert('error', <Trans i18nKey="alerts.error" />)
      })
  }

  return (
    <Grid component="form" container spacing={2} onSubmit={handleConfirmPassword}>
      <Grid item xs={12}>
        <OldPasswordField id="enter-old-password" state={oldPassword} setState={setOldPassword} label={i18n.t('profile.entreprise.security_tab.enter_old_password')} />
      </Grid>
      <Grid item xs={12} md={6}>
        <PasswordField id="enter-new-password" passCheck={passwordCheck} state={newPassword} setState={setNewPassword} label={i18n.t('profile.entreprise.security_tab.new_password')} />
      </Grid>
      <Grid item xs={12} md={6}>
        <PasswordField id="confirm-new-password" passCheck={passwordCheck} state={confirmNewPassword} setState={setConfirmNewPassword} label={i18n.t('profile.entreprise.security_tab.confirm_password')} />
      </Grid>
      <Grid item xs={12} container direction="row" justifyContent="space-between">
        <Typography variant="caption" component="p" style={{ color: 'red' }}>
          {!passwordCheck && (
            <Trans i18nKey="profile.entreprise.security_tab.password_error" />
          )}
        </Typography>
        <Button id="new-password-submit" type="submit" name="submit" variant="contained" size="large" color="primary" startIcon={<Save />}>
          <Trans i18nKey="set_password.save" />
        </Button>
      </Grid>
    </Grid>
  )
}

const OldPasswordField = ({ state, setState, label }) => {
  const [showPassword, setShowPassword] = useState(false)
  return (
    <FormControl variant="filled">
      <InputLabel htmlFor="filled-adornment-password">{label}</InputLabel>
      <FilledInput
        id="outlined-adornment-password"
        disableUnderline
        type={showPassword ? 'text' : 'password'}
        value={state}
        onChange={(e) => setState(e.target.value)}
        endAdornment={
          <InputAdornment position="end">
            <IconButton aria-label="toggle password visibility" onClick={() => setShowPassword(!showPassword)} onMouseDown={(e) => e.preventDefault()} edge="end">
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        }
      />
    </FormControl>
  )
}

const PasswordField = ({ passCheck, state, setState, label }) => {
  const [showPassword, setShowPassword] = useState(false)
  return (
    <FormControl variant="filled">
      <InputLabel htmlFor="filled-adornment-password">{label}</InputLabel>
      <FilledInput
        id="outlined-adornment-password"
        disableUnderline
        error={!passCheck}
        type={showPassword ? 'text' : 'password'}
        value={state}
        onChange={(e) => setState(e.target.value)}
        endAdornment={
          <InputAdornment position="end">
            <IconButton aria-label="toggle password visibility" onClick={() => setShowPassword(!showPassword)} onMouseDown={(e) => e.preventDefault()} edge="end">
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        }
      />
    </FormControl>
  )
}